import * as BuyIntentionModels from 'model/BuyIntention';
import {
  isCardsLayout,
  useResponsiveLayout,
} from 'hooks/layout/useResponsiveLayout';
import AddBuyIntentionTable from './AddBuyIntentionTable';
import BuyIntentionItemCardList from './Cards/BuyIntentionItemCardList';

interface Props {
  tableData: BuyIntentionModels.BuyIntentionData[];
}

export default function BuyIntentionItems({ tableData }: Props) {
  const isCards = isCardsLayout(useResponsiveLayout());

  return isCards ? (
    <BuyIntentionItemCardList tableData={tableData} />
  ) : (
    <AddBuyIntentionTable tableData={tableData} />
  );
}
